/**
 * Value name pair data 
 */
export interface ValueNamePair
{
    /**
     * Value of the pair
     */
    value: string;
    
    /**
     * Name of the pair
     */
    name: string;
}